export default {
  // Navigation & General
  appName: "Smart Growth Advisor",
  appTagline: "Track your child's development journey",
  language: "Language",
  arabic: "Arabic",
  english: "English",
  languageName: "English",
  next: "Next",
  back: "Back",
  submit: "Submit",
  cancel: "Cancel",
  close: "Close",
  watchVideo: "Watch How",
  loading: "Loading...",
  processing: "Analyzing your child's development...",
  viewReport: "View Report",
  addToCart: "Add to Cart",
  lowStock: "Low Stock",
  sar: "SAR",
  save: "Save",
  fillAllFields: "Please fill in all fields",
  validEmailRequired: "Please enter a valid email",
  genericErrorRetry: "An error occurred. Please try again later",
  emailOrPhone: "Email or Phone Number",
  emailOrPhonePlaceholder: "example@domain.com or 05xxxxxxxx",
  password: "Password",
  login: "Login",
  loggingIn: "Logging in...",
  logout: "Logout",
  register: "Register",
  registerNow: "Register now",
  noAccount: "Don't have an account?",
  parentLoginTitle: "Parent Login",
  parentRegisterTitle: "Create Parent Account",
  fullName: "Full Name",
  fullNamePlaceholder: "e.g., Mohammed Ali",
  invalidEmailAddress: "Invalid email address",
  passwordMinError: "Password must be at least 6 characters",
  registrationFailed: "Registration failed. Please check details",
  creatingAccount: "Creating account...",
  createAccount: "Create Account",
  alreadyHaveAccount: "Already have an account?",
  showPassword: "Show password",
  hidePassword: "Hide password",
  invalidCredentials: "Invalid credentials",
  forgotPassword: "Forgot password?",
  toggleTheme: "Toggle Theme",
  languageAndTheme: "Language & Theme",
  personalAccount: "My Account",
  forgotPasswordTitle: "Forgot Password",
  resetLinkSentTitle: "Reset Link Sent!",
  resetLinkSentDesc: "A password reset link has been sent to your email. Please check your inbox.",
  resetLinkValidity: "The link is valid for 15 minutes only",
  backToLogin: "Back to Login",
  forgotPasswordDesc: "Enter your email and we'll send you a link to reset your password",
  emailAddress: "Email Address",
  sending: "Sending...",
  sendResetLink: "Send Reset Link",
  rememberPassword: "Remember your password?",
  resetPasswordTitle: "Reset Password",
  resetPasswordDesc: "Please enter your new password below",
  resetTokenMissing: "Reset token is missing or invalid",
  resetTokenMissingWarning: "Warning: reset token is missing in the URL",
  resetPasswordFailed: "Failed to reset password. The link may have expired",
  passwordsDoNotMatch: "Passwords do not match",
  passwordChangedSuccess: "Password changed successfully!",
  passwordChangedDesc: "You can now log in to your account with your new password.",
  goHomeToLogin: "Go to homepage to log in",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  savePassword: "Save Password",
  parentNameRequired: "Parent Name is required",
  validPhoneRequired: "Invalid phone number",
  validEmailMandatory: "Valid Email is required and mandatory",
  accountPasswordRequired: "Password is required (min 6 characters)",
  childNameRequired: "Child Name is required",
  childDobRequired: "Date of Birth is required",
  selectChildRequired: "Please select a child",
  parentDefaultName: "Parent",
  phoneAlreadyRegistered: "This phone number is already registered",
  emailAlreadyRegistered: "This email is already registered",
  saveReportFailed: "Unable to save report. Please check inputs",
  savePrintReport: "Save & Print Report",
  reportSavedSuccess: "Report Saved Successfully!",
  selectChildForReport: "Select child for this report",
  addNewChildForReport: "Add a new child for this report",
  newAccountPassword: "New Account Password",
  childInformation: "Child Information",
  saveReportAccountNote: "By continuing, you will automatically save this report under your account for future reference and adding more children.",
  saving: "Saving...",
  saveReportLinkAccount: "Save Report & Link to Account",
  viewFinalReport: "View Final Report",
  addAnotherChildStartAssessment: "Add Another Child & Start Assessment",
  requiredFieldsMissing: "Please fill in all required fields",
  addChildFailed: "Unable to add child. Please try again",
  profileFieldsRequired: "Please fill all fields",
  emailOrPhoneAlreadyUsed: "Email or Phone Number is already in use",
  updateChildFailed: "Unable to update child. Please try again",
  customAssessment: "Custom Assessment",
  recommendedGrowthTip: "Recommended Growth Tip",
  recommendedGrowthTipMessage: "Try engaging {{name}} in interactive games and activities suitable for their age to foster cognitive and social skills.",
  amazingMilestone: "Amazing Milestone!",
  amazingMilestoneMessage: "Congratulations! {{name}} achieved an excellent developmental status in their latest evaluation. Keep up the encouragement.",
  name: "Name",
  email: "Email",
  phoneNumber: "Phone Number",
  editDetails: "Edit Details",
  noChildrenAdded: "No children added yet.",
  editChildInfo: "Edit Child Info",
  adding: "Adding...",
  saveChanges: "Save Changes",
  yearSingular: "year",
  yearPlural: "years",
  monthSingular: "month",
  monthPlural: "months",
  and: "and",
  countrySaudiArabia: "Saudi Arabia",
  countryUae: "United Arab Emirates",
  countryKuwait: "Kuwait",
  countryQatar: "Qatar",
  countryBahrain: "Bahrain",
  countryOman: "Oman",
  countryJordan: "Jordan",
  countryEgypt: "Egypt",
  countryLebanon: "Lebanon",
  countrySyria: "Syria",
  countryIraq: "Iraq",
  countryPalestine: "Palestine",
  countryMorocco: "Morocco",
  countryTunisia: "Tunisia",
  countryAlgeria: "Algeria",
  countrySudan: "Sudan",
  countrySomalia: "Somalia",
  countryYemen: "Yemen",
  countryUsa: "USA",
  countryUk: "UK",

  // Landing Page
  heroTitle: "Discover Your Child's Growth Potential",
  heroSubtitle: "A smart assessment tool that helps you understand your child's development across physical, cognitive, and social dimensions.",
  selectAge: "Select Your Child's Age Group",
  ageGroup: "Age Group",
  months: "months",
  years: "years",
  startAssessment: "Start Assessment",
  howItWorks: "How It Works",
  step1Title: "Select Age",
  step1Desc: "Choose your child's age group to get personalized skills assessment.",
  step2Title: "Evaluate Skills",
  step2Desc: "Check the skills your child has mastered across three development pillars.",
  step3Title: "Get Insights",
  step3Desc: "Receive a detailed report with development bars and product recommendations.",

  // Assessment Page
  assessmentTitle: "Skills Assessment",
  assessmentSubtitle: "Check the skills your child has mastered. Click the video icon to see examples.",
  physical: "Physical Development",
  cognitive: "Cognitive Development",
  social: "Social & Emotional Development",
  skillMastered: "Mastered",
  skillNotMastered: "Not Yet",
  progress: "Progress",
  of: "of",
  skillsChecked: "skills checked",
  completeAssessment: "Check",

  // Processing
  processingTitle: "Building Your Report",
  processingSubtitle: "Our system is analyzing the assessment data to create a personalized development report...",

  // Lead Capture
  leadTitle: "Your Assessment is Complete!",
  leadSubtitle: "To save the report, view the colored development bars, and browse recommended products to enhance your child's skills, please enter the following information:",
  childName: "Child's Name",
  childNamePlaceholder: "e.g., First Child",
  dob: "Date of Birth",
  gender: "Gender",
  male: "Male",
  female: "Female",
  parentPhone: "Parent's Phone Number",
  parentEmail: "Parent's Email",
  emailPlaceholder: "For sending the report",
  addAnotherChild: "Add Another Child",
  generateReport: "Generate Report",
  privacyNote: "Your information is secure and will only be used to send the development report.",

  // Report Page
  reportTitle: "Development Report",
  reportSubtitle: "Personalized growth insights for",
  developmentOverview: "Development Overview",
  physicalScore: "Physical",
  cognitiveScore: "Cognitive",
  socialScore: "Social & Emotional",
  developmentStatus: "Development Status",
  excellent: "Excellent",
  good: "Good",
  developing: "Developing",
  needsAttention: "Needs Attention",
  recommendedProducts: "Recommended Products",
  readyToPurchase: "Ready to purchase?",
  checkoutDescription: "Send the available recommended products to the store checkout.",
  goToCheckout: "Go to Checkout",
  processingCheckout: "Preparing checkout...",
  noProductsAvailable: "No products available for checkout",
  checkoutCreateFailed: "Failed to create checkout session",
  noProductsInStock: "No recommended products are currently in stock",
  secureCheckoutMessage: "Products will be sent to the store cart in the store, where the customer can complete the order.",
  productsSubtitle: "Products to help bridge development gaps",
  noProducts: "No products available for this category at the moment.",
  productAvailable: "Available",
  productInCart: "In cart",
  productOutOfStock: "Out of stock",
  productQuantity: "Product quantity",
  decreaseQuantity: "Decrease quantity",
  increaseQuantity: "Increase quantity",
  addProductToCart: "Add product to cart",
  removeProductFromCart: "Remove product from cart",
  suggestedProductsCart: "Suggested products cart",
  suggestedProductsCartHint: "Choose only the products you want, or add all suggested products, then adjust quantities or remove items before opening the store cart.",
  addAllProducts: "Add all products",
  cartEmpty: "Your cart is empty",
  cartEmptyHint: "Add a product from the suggestions or use Add all products.",
  cartItems: "Items",
  cartPieces: "Items",
  cartTotal: "Total",
  cartShipping: "Shipping",
  checkoutInSalla: "Open store cart",
  checkoutInStore: "Open cart in {{storeName}}",
  checkoutCreatePaymentRequest: "Send payment request",
  checkoutPaymentRequestCreated: "Payment request sent successfully. Our team will review the products and send the payment link later.",
  checkoutCreateSallaOrder: "Create store order",
  checkoutSallaOrderCreated: "The order was created in the store successfully. Our team will review it and send the payment link later.",
  sallaStoreFallback: "the store",
  checkoutPrepareFailed: "Unable to prepare the cart right now. Please check the store connection settings, then try again.",
  loadingProductOptions: "Loading product options...",
  productOptionPlaceholder: "Choose",
  productOptionsRequired: "Please choose the required product options before creating the order.",
  storeOrderShippingRequired: "Please choose a shipping address and an available shipping company before creating the order.",
  checkoutShippingAddress: "Shipping address",
  checkoutShippingAddressHint: "Choose a saved address or add a new one. Shipping prices will be loaded from the store for this address.",
  checkoutAddNewAddress: "Add address",
  checkoutSavedAddress: "Saved address",
  checkoutDefaultAddress: "Default",
  checkoutAddressLabel: "Address label, e.g. Home",
  checkoutRecipientName: "Recipient name",
  checkoutRecipientPhone: "Recipient mobile",
  checkoutAddressSearch: "Search address with Google Maps",
  checkoutAddressSearchDisabled: "Add a Google Maps key to enable address search",
  checkoutUseCurrentLocation: "Use my current location",
  checkoutLocationLoading: "Detecting location...",
  checkoutLocationUnsupported: "Your browser does not support location detection.",
  checkoutLocationDenied: "Unable to detect your location. Allow location access and try again.",
  checkoutGoogleMapsLoadFailed: "Unable to load Google Maps right now. You can enter the address or use the current location.",
  checkoutCountryId: "Country",
  checkoutCityId: "City",
  checkoutCountry: "Country",
  checkoutCity: "City",
  checkoutDistrict: "District",
  checkoutLocationsLoading: "Loading locations...",
  checkoutLocationsLoadFailed: "Unable to load countries and cities from the store. Make sure Metadata Read is enabled for the app.",
  checkoutDistrictsLoadFailed: "Unable to load districts from the store. You can type the district name manually.",
  checkoutDistrictId: "District ID",
  checkoutDistrictName: "District name",
  checkoutAddressLine1: "Shipping address",
  checkoutAddressDetails: "Address details",
  checkoutStreetNumber: "Street number",
  checkoutGeoCoordinates: "Coordinates, e.g. 24.7136,46.6753",
  checkoutPostalCode: "Postal code",
  checkoutSaveAddress: "Save address",
  checkoutAddressSaveFailed: "Unable to save the address right now. Please make sure the report is saved and try again.",
  checkoutAddressRequired: "Enter country, city, and shipping address first.",
  checkoutShippingAddressDetailsRequired: "Enter the district name, street number, and coordinates because the selected shipping company requires them.",
  checkoutShippingCompany: "Shipping company",
  shippingRatesLoading: "Loading shipping companies...",
  shippingRatesLoadFailed: "No shipping companies are available for this address right now. Check the store shipping permission and active shipping companies.",
  shippingPermissionRequired: "Shipping companies cannot be loaded because the app does not have the store shipping permission. A draft order will be created in the store without a shipping company.",
  shippingRateRequired: "Choose a shipping company",
  manualPaymentRequestMessage: "Selected products will be sent to the dashboard for review, then a payment link can be sent to the customer later.",
  sallaOrderRequestMessage: "A store order will be created after choosing the customer address and the available shipping company.",
  reportEmailSendFailed: "The report is saved, but the email copy could not be sent right now because of the email service settings.",
  loginRequiredToEmailReport: "Please log in first to send the report",
  reportEmailSentSuccess: "Report sent to your email successfully!",
  temporaryReportTitle: "Temporary child assessment report",
  temporaryReportHint: "To save the report, add it to your child's permanent profile, and access it later, please register.",
  saveReportRegisterChild: "Save Report & Register Child",
  noMasteredSkillsInCategory: "No mastered skills in this category yet.",
  allSkillsMasteredInCategory: "Great job! All skills in this category are mastered.",
  sendViaEmail: "Send via Email",
  resetEmailSendFailed: "The reset link could not be sent right now because of the email service settings.",
  shareReport: "Share Report",
  printReport: "Print Report",
  retakeAssessment: "Retake Assessment",

  // Age Groups
  age0_6: "0 - 6 Months",
  age0_6Subtitle: "Discovery Stage",
  age7_12: "7 - 12 Months",
  age7_12Subtitle: "Exploration Stage",
  age1_2: "1 - 2 Years",
  age1_2Subtitle: "Independence Stage",
  age2_3: "2 - 3 Years",
  age2_3Subtitle: "Launch Stage",
  age3_4: "3 - 4 Years",
  age3_4Subtitle: "Imagination Stage",
  age4_5: "4 - 5 Years",
  age4_5Subtitle: "Logic Stage",
  age5_6: "5 - 6 Years",
  age5_6Subtitle: "School Readiness",

  // Landing Page - Hardcoded translations
  trustedBy: "Trusted by 5000+ families",
  smartAssessment: "Smart Assessment",
  threePillarsShort: "3 Development Pillars",
  methodologySubtitle: "Scientific methodology based on three learning pillars",
  threePillarsTitle: "Three Development Pillars",
  threePillarsDesc: "Assessment based on an algorithm that classifies your child's growth on fundamental learning pillars",
  physicalDesc: "Starts with gross and fine motor skills, develops into visual-motor coordination and tool use",
  cognitiveDesc: "Starts with sound response and cause-effect, develops into logical thinking and creativity",
  socialDesc: "Starts with smiling and attachment, develops into cooperation, rule understanding, and empathy",
  selectAgeSubtitle: "Choose the appropriate age category for your child to start the assessment",
  ctaTitle: "Start your child's development journey today",

  // Assessment
  ageGroupNotFound: "Age group not found",
  reportNotFound: "Report not found",
  dataLoadFailed: "Unable to load data",
  noData: "No data available",
  notAvailable: "Not available",

  // Report
  yourChild: "your child",
  assessedSummary: "Assessed {{checked}} of {{total}} skills. {{status}} overall development.",

  // NotFound
  pageNotFound: "Page Not Found",
  pageNotFoundDesc: "Sorry, the page you are looking for is not available. It may have been moved or deleted.",
  backToHome: "Back to Home",

  // Report - Skills & Products
  skillsToDevelop: "Skills to Develop",
  skillsToDevelopDesc: "Each missing skill with recommended practice products",
  masteredSkillsTitle: "Mastered Skills",
  masteredSkillsDesc: "Each mastered skill with products to boost creativity",
  suggestedProducts: "Suggested Practice Products",
  creativityProducts: "Creativity Boosting Products",
  skills: "skills",

  // Lead Capture Modal
  printReportTitle: "Print Report",
  printReportDesc: "Register your details to save the report and access it later",
  parentName: "Parent Name",
  parentNamePlaceholder: "e.g., Mohammed Ali",
  verifyPhone: "Verify Phone Number",
  otpSentTo: "Verification code sent to",
  enterOtp: "Enter Verification Code",
  otpSentDesc: "Enter the 4-digit code sent to",
  changePhone: "Change Phone Number",
  confirmOtp: "Confirm Code",
  verifyAndContinue: "Verify & Continue",
  requiredField: "This field is required",
  invalidPhone: "Invalid phone number",
  invalidEmail: "Invalid email address",
  invalidOtp: "Invalid verification code",
  phonePlaceholder: "5X XXX XXXX",
  accountNote: "An account will be created automatically. You can access reports later and add more children.",

  // Admin
  adminTitle: "Admin Dashboard",
  adminWelcome: "Welcome, {{name}}",
  adminLoginTitle: "Admin Login",
  adminLoginSubtitle: "Sign in to manage content and permissions",
  adminEmail: "Email",
  adminEmailPlaceholder: "example@domain.com",
  adminPassword: "Password",
  adminPasswordPlaceholder: "••••••••",
  adminSignIn: "Sign In",
  adminLoggingIn: "Signing in",
  adminInvalidCredentials: "Invalid credentials",
  adminRememberMe: "Remember me",
  adminLogout: "Logout",
  adminDashboard: "Dashboard",
  adminAgeGroups: "Age Groups",
  adminCategories: "Categories",
  adminSkills: "Skills",
  adminProducts: "Store Products",
  adminOrders: "Store Orders",
  adminMappings: "Product Mapping",
  adminCrm: "CRM",
  adminParents: "Parents",
  adminChildren: "Children",
  adminReports: "Reports",
  adminName: "Admin name",
  adminOverview: "Overview",
  adminTotalAgeGroups: "Total age groups",
  adminTotalCategories: "Total categories",
  adminTotalSkills: "Total skills",
  adminTotalProducts: "Total products",
  adminTotalParents: "Total parents",
  adminTotalChildren: "Total children",
  adminTotalReports: "Total reports",
  adminAgeGroupKey: "Key",
  adminAgeGroupName: "Age group name",
  adminAgeGroupRange: "Age range",
  adminAgeGroupManageHint: "Add or update age groups with translations",
  adminAddAgeGroup: "Add Age Group",
  adminEditAgeGroup: "Edit Age Group",
  adminClose: "Close",
  adminTranslationValue: "Translation text",
  adminTranslationHint: "Pick a language and enter the text. If a secondary language is empty it will be filled from the default language.",
  adminTranslations: "Translations",
  adminLocales: "Locales",
  adminStatus: "Status",
  adminActions: "Actions",
  adminMinMonths: "Min months",
  adminMaxMonths: "Max months",
  adminTranslationLabel: "{{language}} translation",
  adminCreate: "Create",
  adminUpdate: "Update",
  adminCancel: "Cancel",
  adminEdit: "Edit",
  adminDisable: "Disable",
  adminEnable: "Enable",
  adminFillRequired: "Please fill the required fields",
  adminFillTranslations: "Please provide at least one translation",
  adminSaveFailed: "Unable to save data",
  adminCategoryKey: "Category key",
  adminCategoryName: "Category name",
  adminCategoryColor: "Color",
  adminCategoryManageHint: "Add or update categories with translations",
  adminAddCategory: "Add Category",
  adminEditCategory: "Edit Category",
  adminCategoryIcon: "Category icon",
  adminSkillKey: "Skill key",
  adminSkillId: "Skill ID",
  adminSkillName: "Skill name",
  adminSkillTitle: "Skill name",
  adminSkillAgeGroup: "Age group",
  adminSkillCategory: "Category",
  adminSkillStatus: "Status",
  adminSkillManageHint: "Add or update skills with translations",
  adminAddSkill: "Add Skill",
  adminEditSkill: "Edit Skill",
  adminSkillIcon: "Skill icon",
  adminSkillVideoUrl: "Video URL",
  adminSkillSearch: "Search",
  adminSkillSearchPlaceholder: "Search by skill, category, or age group",
  adminFilterCategory: "Category",
  adminFilterAgeGroup: "Age group",
  adminFilterStatus: "Status",
  adminAll: "All",
  adminRowsPerPage: "Rows per page",
  adminResultsCount: "Results: {{count}}",
  adminExportSkills: "Export skills",
  adminExporting: "Exporting",
  adminNoData: "No data yet",
  adminNoResults: "No results found",
  adminPageStatus: "Page {{current}} of {{total}}",
  adminPrevPage: "Previous",
  adminNextPage: "Next",
  adminSettings: "Admin Settings",
  adminSettingsHint: "Manage admins, branding, colors, email, and SEO",
  adminSettingsTabAdmins: "Admins",
  adminSettingsTabSmtp: "SMTP",
  adminSettingsTabBranding: "Branding",
  adminSettingsTabTheme: "Theme",
  adminSettingsTabSeo: "SEO",
  adminRole: "Role",
  adminRoleSuper: "Super Admin",
  adminRoleEditor: "Content Editor",
  adminPasswordOptional: "Leave blank to keep current password",
  adminPasswordMin: "Password must be at least 6 characters",
  adminSaveSuccess: "Settings saved successfully",
  adminSaveSettings: "Save settings",
  adminStatusActive: "Account is active",
  adminSiteName: "Site name",
  adminSiteTagline: "Tagline",
  adminLogoUrl: "Site logo",
  adminFaviconUrl: "Browser icon",
  adminPrimaryColor: "Primary color",
  adminSecondaryColor: "Secondary color",
  adminAccentColor: "Accent color",
  adminFontFamily: "Font",
  adminSeoTitle: "Homepage title",
  adminSeoDescription: "Homepage description",
  adminSeoKeywords: "Keywords",
  adminSeoOgImage: "Share image",
  adminSmtpEnabled: "Enable SMTP",
  adminSmtpHost: "SMTP host",
  adminSmtpSecurity: "Connection type",
  adminSmtpSecurityTls: "TLS",
  adminSmtpSecuritySsl: "SSL",
  adminSmtpAllowSelfSigned: "Allow self-signed certificates",
  adminSmtpPort: "SMTP port",
  adminSmtpUser: "SMTP user",
  adminSmtpPassword: "SMTP password",
  adminSmtpFromName: "From name",
  adminSmtpFromEmail: "From email",
  adminSmtpTestEmail: "Test email",
  adminSmtpTestButton: "Send test",
  adminSmtpTestSuccess: "Test email sent successfully",
  adminSmtpTestFailed: "SMTP test failed",
  adminSmtpPresetGmail: "Gmail",
  adminSmtpPresetMicrosoft: "Microsoft",
  adminSmtpPresetYahoo: "Yahoo",
  adminSmtpPresetIcloud: "iCloud",
  adminSmtpPresetZoho: "Zoho",
  adminSmtpPresetHint: "Sets host, port, and connection type",
  adminVisitWebsite: "Visit Website",
  adminSallaTab: "Store",
  adminNotSet: "Not set",
  adminEveryMinutes: "Every {{count}} minutes",
  adminEveryHours: "Every {{count}} hour",
  adminEveryHours_plural: "Every {{count}} hours",
  adminSallaDisconnectConfirm: "This will delete the current store connection tokens and disable sync. Products will not be deleted. Continue?",
  adminSallaDisconnectSuccess: "Store connection disconnected successfully",
  adminSallaDisconnectFailed: "Failed to disconnect Store connection",
  adminSallaConnectionStatus: "Store connection status",
  adminSallaNoConnection: "No store is currently connected.",
  adminSallaDisconnect: "Disconnect store",
  adminSallaAutoSync: "Enable automatic sync",
  adminSallaAutoSyncHint: "When enabled, store products will be updated according to the selected interval.",
  adminSallaCheckoutRedirectMode: "Recommendation redirect behavior",
  adminSallaCheckoutRedirectModeHint: "Choose whether customers open the store cart, go to checkout, create an internal request, or create a real order in the store.",
  adminSallaRedirectToCart: "Send products to store cart",
  adminSallaRedirectToCartHint: "Default test option; lets customers review products before completing the order.",
  adminSallaRedirectToCheckout: "Create checkout directly",
  adminSallaRedirectToCheckoutHint: "Opens the checkout URL returned by the store after the cart is prepared.",
  adminSallaRedirectToPaymentRequest: "Dashboard payment request",
  adminSallaRedirectToPaymentRequestHint: "Saves the products as an internal request so admins can review them and send the payment link later.",
  adminSallaRedirectToSallaOrder: "Create store order",
  adminSallaRedirectToSallaOrderHint: "Creates a real order in the store and stores its links for review and later delivery.",
  adminSallaOrderPaymentMethod: "Payment method for store orders",
  adminSallaOrderPaymentMethodPlaceholder: "Choose an active payment method",
  adminSallaOrderPaymentMethodHint: "Only active online payment methods appear here. Choose the method the store will use when creating orders.",
  adminSallaOrderPaymentMethodRequired: "Choose an active payment method before saving the store order option.",
  adminSallaOrderShippingCompany: "Shipping company for store orders",
  adminSallaOrderShippingCompanyPlaceholder: "Choose an active shipping company",
  adminSallaOrderShippingCompanyHint: "Only active store shipping companies appear here. Make sure the app has the shipping permission enabled.",
  adminSallaOrderShippingCompanyRequired: "Choose an active shipping company before saving the store order option.",
  adminSallaOrderShippingCost: "Displayed shipping cost",
  adminSallaOrderShippingCostHint: "This value appears to the customer in our order total.",
  adminSallaOrderShipToCountryId: "Country ID",
  adminSallaOrderShipToCityId: "City ID",
  adminSallaOrderShipToDistrictId: "District ID",
  adminSallaOrderShipToAddress: "Shipping address",
  adminSallaOrderShipToAddressLine: "Address details",
  adminSallaOrderShipToPostalCode: "Postal code",
  adminSallaOrderShippingAddressHint: "These fields are sent with the store order when using shipping. They can be replaced later when customer address capture is supported.",
  adminSallaOrderShippingAddressRequired: "Enter country ID, city ID, and shipping address before saving the store order option.",
  adminOrdersTotal: "Total orders",
  adminOrdersStoreOrders: "Store orders",
  adminOrdersInternalRequests: "Internal requests",
  adminOrdersLoadFailed: "Unable to load store orders.",
  adminOrdersNoData: "No orders yet",
  adminOrderTypeStore: "Store order",
  adminOrderTypeInternal: "Internal request",
  adminOrdersUnknownCustomer: "Unknown customer",
  adminOrdersAmount: "Amount",
  adminOrdersItems: "Items",
  adminOrdersPhone: "Phone",
  adminOrdersStoreOrderNumber: "Order number",
  adminOrdersOpenInDashboard: "Open in store dashboard",
  adminOrdersOpenCustomerLink: "Customer link",
  adminOrdersOpenPaymentLink: "Payment link",
  adminOrderStatusPending: "Pending review",
  adminOrderStatusStoreOrderCreated: "Store order created",
  adminOrderStatusCompleted: "Completed",
  adminOrderStatusCancelled: "Cancelled",
  adminOrderStatusUnknown: "Unknown status",
  adminSallaTimezone: "Time zone",
  adminSallaSyncInterval: "Sync interval",
  adminSallaLastStarted: "Last sync start",
  adminSallaLastCompleted: "Last sync completion",
  adminSallaNextRun: "Next sync",
  adminSallaProductPullType: "Products to pull",
  adminSallaActiveOnly: "Pull active products only",
  adminSallaAllProducts: "Pull all products",
  adminSallaLocalStockThreshold: "Local stock threshold",
  adminSallaLocalStockThresholdHint: "If the product quantity in the store is less than or equal to this value, it will be stored locally as zero so it does not appear in recommendations.",
  adminSallaCategoriesNeedConnection: "Store categories appear only after the app is connected successfully and installation data is received .",
  adminSallaCategories: "Store categories",
  adminSallaCategoriesHint: "Leave empty to pull all categories, or choose specific categories only.",
  adminClearSelection: "Clear selection",
  adminSallaNoCategories: "No Store categories loaded yet. Make sure the app is installed and the token has been received.",
  adminSelectAgeGroup: "Select age group",
  adminSelectCategory: "Select category",
  adminMediaTabIcon: "Icons",
  adminMediaTabSvg: "SVG",
  adminMediaTabImage: "Images",
  adminMediaEmpty: "No media yet",
  adminMediaSelected: "Selected",
  adminMediaUploadFailed: "Unable to upload file",
  adminMediaSearchPlaceholder: "Search icon or file...",
  adminMediaCategoryChildDev: "Child Development (Curated)",
  adminMediaCategoryTabler: "Tabler Icons",
  adminMediaCategoryLucide: "Lucide Icons",
  adminMediaCategoryAll: "All Libraries",
  adminMediaNoIcons: "No icons found",
  adminMediaShowingIcons: "Showing first {{visible}} icons of {{total}}. Type in search to narrow down.",
  adminIconPreview: "Preview",
  adminActive: "Active",
  adminInactive: "Inactive",
  adminProductId: "Product ID",
  adminProductPrice: "Price",
  adminProductStock: "Stock",
  adminMappingProduct: "Product",
  adminMappingCategory: "Category",
  adminMappingAgeGroup: "Target age",
  dbColSallaProductId: "Store Product ID",
  dbColSku: "Product SKU",
  dbColPrice: "Price",
  dbColImageUrl: "Image URL",
  dbColStockQuantity: "Stock Quantity",
  dbColNameAr: "Product Name (Arabic)",
  dbColNameEn: "Product Name (English)",

  // Account Page
  myAccount: "My Account",
  myChildren: "My Children",
  reports: "Reports",
  myOrders: "My Orders",
  notifications: "Notifications",
  settings: "Settings",
  born: "Date of Birth",
  age: "Age",
  lastAssessment: "Last Assessment",
  newAssessment: "New Assessment",
  addChild: "Add Child",
  allChildren: "All Children",
  noReportsYet: "No reports yet",
  noOrdersYet: "No orders yet",
  accountOrderTypeStore: "Store order",
  accountOrderTypeInternal: "Internal request",
  accountOrderStatusPending: "Pending review",
  accountOrderStatusStoreOrderCreated: "Store order created",
  accountOrderStatusCompleted: "Completed",
  accountOrderStatusCancelled: "Cancelled",
  accountOrderStatusUnknown: "Unknown status",
  accountOrderUnknownChild: "Unknown child",
  accountOrderAmount: "Amount",
  accountOrderItems: "Items",
  accountOrderPaymentLink: "Open payment link",
  accountOrderDetailsLink: "Order details",
  noNotifications: "No notifications",

  // Footer
  footerRights: "All rights reserved.",
  footerTagline: "Empowering parents with smart growth insights.",
};
